<template>
  <div class="page-layout" data-track="Review Invitations History">
    <div class="columns is-align-items-center margin-0">
      <div class="column is-3-mobile is-5-desktop is-5-widescree p-y-0 p-x-0">
        <div class="level">
          <div class="level-left">
            <div class="page-layout-head">Invite History</div>
          </div>
        </div>
      </div>
      <div class="column p-y-0 p-x-0 is-flex is-align-items-center header-filters">
        <a class="about-feature" target="_blank"
           href="https://intercom.help/hellopeter/en/articles/4228174-review-invites">
          <img src="/static/img/dummy-help.png"/>
          <span class="abt_section">About this feature</span>
        </a>
        <date-select-filter
          class="custom-dropdown"
          :reviews_start_date="filters.dateFilter.reviews_start_date"
          :filter_items="filters.dateFilter.props"
          :styleProp="filters.dateFilter.styleProp"
          @onDateChange="handleDateChange"
          data-track="Review invite history - Change date"
        />
        <a
          :disabled="!isPaidUser"
          :href="isPaidUser ? exportHistoryReviews : `javascript:void(0)`"
          class="button is-hidden-mobile export-button"
          data-track="Review invite history - Export"
        >EXPORT
        </a>
        <a
          :disabled="!isPaidUser"
          :href="isPaidUser ? exportHistoryReviews : `javascript:void(0)`"
          class="button is-hidden-tablet is-fullwidth export-button"
          data-track="Review invite history - Export"
          v-if="isPaidUser ? true : `javascript:void(0)`"
        >EXPORT
        </a>
      </div>
    </div>
    <hr class="page-layout-horizontal-row">
    <div class="invite-history">
      <!-- Stats Card Begins -->
      <div class="stats-box is-flex">
        <div class="stats-box__col has-text-right">
          <div class="stats-box__col-head pad-right-89">
            Total invites <strong class="font-size-13">sent</strong>
          </div>
          <div class="has-text-weight-bold pad-right-89">
            <div class="margin-top-10">Opens</div>
            <div class="margin-top-10 margin-bottom-7">Clicks</div>
            <div class="margin-bottom-7">Conversion rate</div>
          </div>
        </div>
        <div class="stats-box__col">
          <div class="stats-box__col-head padding-top-10 padding-bottom-9">
            <img src="/static/img/analytics/envelop_small.svg" class="valign-top margin-right-7" alt="envelop"/>
            Email
            <strong class="pad-left-13">{{ analyticsData.stats.emailInvites || 0 | formatDigit }}</strong>
          </div>
          <div>
            <div class="margin-top-10">
              {{ analyticsData.stats.opened || 0 }}
              <span class="stats-box__divider">|</span>
              {{ Math.round(calculateRate(analyticsData.stats.opened, analyticsData.stats.emailInvites, analyticsData.stats.bounced)) }}%
            </div>
            <div class="margin-top-10 margin-bottom-7">
              {{ analyticsData.stats.clicked || 0 }}
              <span class="stats-box__divider">|</span>
              {{ Math.round(calculateRate(analyticsData.stats.clicked, analyticsData.stats.emailInvites, analyticsData.stats.bounced)) }}%
            </div>
            <div class="margin-bottom-7">
              {{ analyticsData.stats.emailConverted || 0 }}
              <span class="stats-box__divider">|</span>
              {{ Math.round(calculateRate(analyticsData.stats.emailConverted, analyticsData.stats.emailInvites, analyticsData.stats.bounced)) }}%
            </div>
          </div>
        </div>
        <div class="stats-box__col">
          <div class="stats-box__col-head padding-top-10 padding-bottom-9">
            <img src="/static/img/analytics/sms_small.svg" class="valign-top margin-right-7" alt="envelop"/>
            SMS
            <strong class="pad-left-13">{{ analyticsData.stats.smsInvites || 0 | formatDigit }}</strong>
          </div>
          <div>
            <div class="margin-top-10">
              &nbsp;
            </div>
            <div class="margin-top-10 margin-bottom-7">
              &nbsp;
            </div>
            <div class="margin-bottom-7">
              {{ analyticsData.stats.smsConverted || 0 }}
              <span class="stats-box__divider">|</span>
              {{ Math.round(calculateRate(analyticsData.stats.smsConverted, analyticsData.stats.smsInvites)) }}%
            </div>
          </div>
        </div>
        <div class="stats-box__col">
          <div class="stats-box__col-head padding-top-10 padding-bottom-9">
            <img src="/static/img/review-invites/whatsapp_logo_3x.png" class="valign-top margin-right-7 w15" alt="envelop"/>
            WhatsApp
            <strong class="pad-left-13">{{ analyticsData.stats.whatsappInvites || 0 | formatDigit }}</strong>
          </div>
          <div>
            <div class="margin-top-10">
              &nbsp;
            </div>
            <div class="margin-top-10 margin-bottom-7">
              &nbsp;
            </div>
            <div class="margin-bottom-7">
              {{ analyticsData.stats.whatsappConverted || 0 }}
              <span class="stats-box__divider">|</span>
              {{ Math.round(calculateRate(analyticsData.stats.whatsappConverted, analyticsData.stats.whatsappInvites)) }}%
            </div>
          </div>
        </div>
        <div class="stats-box__col">
          <div class="stats-box__col-head padding-top-10 padding-bottom-9">
            <img src="/static/img/review-invites/google_logo_3x.png" class="valign-top margin-right-7 w15" alt="envelop"/>
            Google
            <strong class="pad-left-13">{{ analyticsData.stats.googleInvites || 0 | formatDigit }}</strong>
          </div>
          <div>
            <div class="margin-top-10">
              {{ analyticsData.stats.googleOpened || 0 }}
              <span class="stats-box__divider">|</span>
              {{ Math.round(calculateRate(analyticsData.stats.googleOpened, analyticsData.stats.googleInvites, analyticsData.stats.googleBounced)) }}%
            </div>
            <div class="margin-top-10 margin-bottom-7">
              {{ analyticsData.stats.googleClicked || 0 }}
              <span class="stats-box__divider">|</span>
              {{ Math.round(calculateRate(analyticsData.stats.googleClicked, analyticsData.stats.googleInvites, analyticsData.stats.googleBounced)) }}%
            </div>
            <div class="margin-bottom-7">&nbsp;</div>
          </div>
        </div>
      </div>
      <!-- Stats Card  Ends-->
      <div>
        <div class="level direction-column table-container" v-if="!is_loading">
          <table class="table is-size-7-touch is-marginless is-fullwidth">
            <thead>
            <tr>
              <td class="cb-head-col">
                <a v-if="!fetching_data && reviewInvitationHistory.length" class="blue-link" :class="{'link-disabled': bulkInvites.isSending}"
                   data-track="Review invite history - Resend all" href="#"
                   @click.prevent="sendBulkInvitesCnfm">
                  RESEND
                  <template v-if="bulkInvitesCount"> ({{ bulkInvitesCount }})</template>
                  <template v-else> ALL</template>
                </a>
              </td>
              <td class="is-narrow-mobile is-size-7-desktop has-text-weight-bold">Date</td>
              <td class="is-narrow-mobile is-size-7-desktop has-text-weight-bold">Name</td>
              <td class="is-narrow-mobile is-size-7-desktop has-text-weight-bold">Email</td>
              <td class="is-narrow-mobile is-size-7-desktop has-text-weight-bold">Email Template</td>
              <td class="is-narrow-mobile is-size-7-desktop has-text-weight-bold">Mobile number</td>
              <td class="is-narrow-mobile is-size-7-desktop has-text-weight-bold has-text-centered">Opened</td>
              <td class="is-narrow-mobile is-size-7-desktop has-text-weight-bold has-text-centered">Clicks</td>
              <td class="is-narrow-mobile is-size-7-desktop has-text-weight-bold has-text-centered">Converted</td>
              <td class="is-narrow-mobile is-size-7-desktop has-text-weight-bold">Channel</td>
            </tr>
            </thead>
            <tbody>
            <tr v-if="(is_loading && reviewInvitationHistory.length === 0) || (!fetching_data && reviewInvitationHistory.length === 0)">
              <td class="is-narrow pad70-desktop is-size-7-mobile is-size-7-desktop has-text-weight-bold has-text-grey" colspan="12">
                <p class="has-text-centered is-padded-20">No results found</p>
              </td>
            </tr>
            <template v-for="(history, index) in reviewInvitationHistory" v-if="reviewInvitationHistory.length > 0">
              <tr class="margin-bottom-20 table-rows">
                <td class="cb-col">
                  <template v-if="canResend(history)">
                    <colored-checkbox
                      v-if="canAddToBulkResend(history)"
                      :is-disabled="bulkInvites.isSending"
                      :is-checked="isCheckedForResend(history)"
                      @cb-toggle="addToBulkResend($event, history)">
                    </colored-checkbox>
                    <span v-else class="mock-cb">&nbsp;</span>

                    <span v-if="history.file_uploaded_emails.length" @click="expandRow(index)" class="pointer pad-left-21">
                      <img src="/static/img/review-invites/folder_3x.png" class="w14" alt="folder">
                      <img class="margin-left-4" :src="`/static/img/review-invites/${!reviewInvitationHistory[index].expanded ? 'right' : 'down'}_arrow_3x.png`"
                           :class="{'valign-baseline':!reviewInvitationHistory[index].expanded, 'w7':!reviewInvitationHistory[index].expanded, 'w12':reviewInvitationHistory[index].expanded, 'margin-top-5':reviewInvitationHistory[index].expanded}"
                           alt="expand">
                    </span>
                  </template>
                </td>
                <td class="is-narrow-mobile is-desktop">{{ history.created_at | notificationDate }}</td>
                <td class="is-narrow-mobile is-desktop">{{ (!history.file_uploaded ? history.first_name : history.file)|formatString }}</td>
                <td class="is-narrow-mobile is-desktop">{{ history.email|formatString }}</td>
                <td class="is-narrow-mobile is-desktop">{{ history.type === 'INMAIL' ? 'In-mail' : (!history.file_uploaded ? 'Landing page' : '') }}</td>
                <td class="is-narrow-mobile is-desktop hovernwe">
                  <template v-if="'mobile' in history && history.mobile">
                    {{ history.mobile }}
                  </template>
                  <template v-else>{{ !history.file_uploaded ? 'Not provided' : '' }}</template>
                </td>
                <td class="is-narrow-mobile is-desktop hovernwe has-text-centered">
                      <span>
                          {{ !history.file_uploaded ? getOpens(history) : countConversionStats(history.file_uploaded_emails, 'opens') }}
                      </span>
                </td>
                <td class="is-narrow-mobile is-desktop hovernwe has-text-centered">
                      <span>
                          {{ !history.file_uploaded ? getClicks(history) : countConversionStats(history.file_uploaded_emails, 'clicks') }}
                      </span>
                </td>
                <td class="is-narrow-mobile is-desktop hovernwe converted-section has-text-centered">
                      <span>
                        <span v-if="history.converted !== null">
                          <i class="fas fa-check"></i> {{ history.converted | prettyDate }}
                        </span>
                        <span v-else>
                          <a
                            href="#"
                            data-track="Review invite history - Resend invite"
                            class="has-text-underlined color-2aabe1 f12"
                            v-if="canAddToBulkResend(history) && !history.file_uploaded"
                            @click.prevent="sendSingleInviteCnfm(history.email, history.conversion_token)"
                          >RESEND
                          </a>
                          <span v-else>{{ history.type !== 'GMB' ? countConversionStats(history.file_uploaded_emails, 'conversions') : '' }}</span>
                        </span>
                      </span>
                </td>
                <td class="is-narrow-mobile is-desktop hovernwe">
                  <span>{{ !history.file_uploaded ? getChannel(history) : '' }}</span>
                </td>
              </tr>
              <tr class="file-table-rows" v-for="(file, key) in history.file_uploaded_emails" v-if="reviewInvitationHistory[index].expanded">
                <td class="is-narrow-mobile is-desktop" colspan="2">
                  <colored-checkbox
                    v-if="canAddToBulkResend(file)"
                    :is-disabled="bulkInvites.isSending"
                    :is-checked="isCheckedForResend(file)"
                    @cb-toggle="addToBulkResend($event, file)">
                  </colored-checkbox>
                </td>
                <td class="is-narrow-mobile is-desktop">{{ (!file.file_uploaded ? file.first_name : history.file)|formatString }}</td>
                <td class="is-narrow-mobile is-desktop">{{ file.email|formatString }}</td>
                <td class="is-narrow-mobile is-desktop">{{ file.type === 'INMAIL' ? 'In-mail' : (!file.file_uploaded ? 'Landing page' : '') }}</td>
                <td class="is-narrow-mobile is-desktop hovernwe">
                  <template v-if="activeSubscription.name === 'Free'">
                  </template>
                  <template v-else-if="'mobile' in file && file.mobile">
                    {{ isPaidUser ? file.mobile : '' }}
                  </template>
                  <template v-else>{{ !file.file_uploaded ? 'Not provided' : '' }}</template>
                </td>
                <td class="is-narrow-mobile is-desktop hovernwe has-text-centered">
                    <span>
                        {{ !file.file_uploaded ? getOpens(file) : '2/25' }}
                    </span>
                </td>
                <td class="is-narrow-mobile is-desktop hovernwe has-text-centered">
                    <span>
                        {{ !file.file_uploaded ? getClicks(file) : '4/25' }}
                    </span>
                </td>
                <td class="is-narrow-mobile is-desktop hovernwe converted-section has-text-centered">
                    <span>
                      <span v-if="file.converted !== null">
                        <i class="fas fa-check"></i> {{ file.converted | prettyDate }}
                      </span>
                      <span v-else>
                        <a
                          href="#"
                          data-track="Review invite history - Resend invite"
                          class="has-text-underlined color-2aabe1 f12"
                          v-if="canAddToBulkResend(file) && !file.file_uploaded"
                          @click.prevent="sendSingleInviteCnfm(file.email, file.conversion_token)"
                        >RESEND
                        </a>
                      </span>
                    </span>
                </td>
                <td class="is-narrow-mobile is-desktop hovernwe">
                  <span>{{ !file.file_uploaded ? getChannel(file) : '' }}</span>
                </td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
        <div class="level level-right">
          <paginator :dataSet="dataSet" @changed="getReviewInvitationsHistory"></paginator>
        </div>
      </div>

      <modal-new :show="bulkInvitesModal.show" :closeFn="closeBulkInvites" :submitBtn="{text:'RESEND INVITES', fn:sendBulkInvites}">
        <template slot="header">
          Resend review Invites?
        </template>
        <div>You are about to resend <strong>{{ invitesCountForModal }}</strong> email review invites.</div>
        <br>
        <p><i>The <strong>current email invite template</strong> will be sent when resending review invites. SMS invites will <strong>not</strong> be sent.</i></p>
        <br>
        <p>Are you sure you want to resend?</p>
      </modal-new>
    </div>
  </div>
</template>
<script>
/* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape */
import axios from 'axios'
import moment from 'moment'
import misc from '../../mixins/misc.js'
import {ColoredCheckbox, DateSelectFilter, ModalNew} from '@/components'
import qs from 'qs'
import Paginator from '../../components/Paginator'
import {mapActions, mapState} from 'vuex'
import {FETCH_REVIEW_INVITE_ANALYTICS_STATS} from '@/store/action.types'

export default {
  name: 'ReviewInviteHistory',
  metaInfo: {
    title: 'Business Portal | Hellopeter - Review Invites History'
  },
  mixins: [misc],
  components: {
    DateSelectFilter,
    Paginator,
    ColoredCheckbox,
    ModalNew
  },
  data () {
    return {
      authToken: localStorage.getItem('auth_token'),
      businessSlug: localStorage.getItem('org_slug'),
      filters: {
        dateFilter: {
          label: 'All time',
          endDate: null,
          startDate: null,
          reviews_start_date: '',
          props: [
            {
              name: 'date',
              label: 'Date',
              showApplyBtn: true,
              default: {type: 'months', value: 6, selected: 'All time'}, // moment.js placeholder in type
              disabled: [],
              elements: [
                'Last 7 days',
                'Previous month',
                'Last 6 months',
                'Last 12 months',
                'All time',
                'Custom'
              ]
            }
          ]
        }
      },

      file: '',
      is_loading: false,
      fetching_data: false,
      reviewInvitationHistory: [],
      dataSet: {},
      activeSubscription: {},
      historyFilters: {
        starRating: null,
        dateFilter: {
          label: 'last_6_months',
          endDate: null,
          startDate: null,
          styleProp: {},
          reviews_start_date: '',
          props: [
            {
              name: 'date',
              label: 'Date',
              showApplyBtn: true,
              default: {type: 'months', value: 6, selected: 'Last 6 months'}, // moment.js placeholder in type
              disabled: [],
              elements: [
                'Last 7 days',
                'Previous month',
                'Last 6 months',
                'Last 12 months',
                'Custom'
              ]
            }
          ]
        }
      },
      bulkInvites: {
        isSending: false,
        data: {}
      },
      bulkInvitesModal: {
        show: false,
        isSingleSend: false
      },
      singleInvite: {},
      allCount: 0
    }
  },
  computed: {
    /**
     * Get link to export review analytics data
     * @return {string}
     */
    exportHistoryReviews () {
      const authToken = qs.stringify({token: this.authToken})
      const url = `/marketing/${this.businessSlug}/export-review-invitation-history?startDate=${this.filters.dateFilter.startDate}&endDate=${this.filters.dateFilter.endDate}&${authToken}`
      return process.env.API_URL + url
    },
    ...mapState({
      analyticsData: state => state.analytics.reviewInvites
    }),
    bulkInvitesCount () {
      return Object.keys(this.bulkInvites.data).length
    },
    invitesCountForModal () {
      if (this.bulkInvitesModal.isSingleSend) {
        return 1
      }

      if (this.bulkInvitesCount) {
        return this.bulkInvitesCount
      }

      return this.allCount
    },
    /**
     * Creating a payload for HTTP request
     * @return {object}
     */
    payload () {
      return {
        endDate: this.historyFilters.dateFilter.endDate,
        startDate: this.historyFilters.dateFilter.startDate,
        businessSlug: this.businessSlug
      }
    },
    /**
     * Number of total invites (Email, SMS) Combined
     * @return {Number}
     */
    totalInvites () {
      return this.analyticsData.stats.emailInvites + this.analyticsData.stats.smsInvites
    }
  },
  created () {
    this.getBusinessInfo()

    this.$on('dateFilterChangeFromInviteLayout', (dateFilter) => {
      this.historyHandleDateChange(dateFilter)
    })
    this.historyHandleDateChange(this.filters.dateFilter)
  },
  mounted () {
    this.$gtm.trackEvent({
      event: 'pageLoad',
      virtualPageUrl: this.$router.currentRoute.path,
      virtualPageTitle: 'Review invite history'
    })
  },
  beforeDestroy () {
    this.$off('dateFilterChangeFromInviteLayout')
  },
  methods: {
    /**
     * Get basic informations about business
     * @return {Promise}
     */
    getBusinessInfo () {
      return new Promise((resolve) => {
        axios.get(`business/${this.businessSlug}/info`)
          .then(({data}) => {
            this.filters.dateFilter.reviews_start_date = data.data.reviewInvite.firstInvite ? moment(data.data.reviewInvite.firstInvite.created_at).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
            resolve(data.data)
          })
          .catch((error) => {
            flash(error.message, 'is-danger')
          })
      })
    },
    /**
     * Handle Date Dropdown Filter
     * @param {object} dateFilter Date data to sort on
     * @return {void}
     */
    handleDateChange (dateFilter) {
      Object.assign(this.filters.dateFilter, dateFilter)
      if (dateFilter.label === 'all_time') {
        this.filters.dateFilter.startDate = this.filters.dateFilter.reviews_start_date
        this.filters.dateFilter.endDate = moment().format('YYYY-MM-DD')
      }
      this.$emit('dateFilterChangeFromInviteLayout', this.filters.dateFilter)
    },
    ...mapActions({
      fetchReviewInvitesAnalytics: `analytics/${FETCH_REVIEW_INVITE_ANALYTICS_STATS}`
    }),
    closeBulkInvites () {
      this.bulkInvitesModal.show = false
    },
    sendBulkInvites () {
      if (this.bulkInvitesModal.isSingleSend) {
        this.resendInvites(this.singleInvite.email, this.singleInvite.token)
      } else {
        this.bulkInvites.isSending = true
        const failMessage = 'An unexpected error occurred. Please try again later'
        let prom

        if (this.bulkInvitesCount) {
          prom = axios.post(`/marketing/${this.businessSlug}/resend-business-review-invitations-bulk`, {
            data: this.bulkInvites.data
          })
            .then(({data}) => {
              if (data.status === 'success') {
                this.$set(this.bulkInvites, 'data', {})
                return {data}
              }
            })
        } else {
          prom = axios.post(`/marketing/${this.businessSlug}/resend-business-review-invitations-all`, {
            startDate: this.historyFilters.dateFilter.startDate,
            endDate: this.historyFilters.dateFilter.endDate
          })
        }

        prom.then(({data}) => {
          if (data.status === 'success') {
            this.getReviewInvitationsHistory()
            flash(`Review invitations successfully sent`, 'is-success')
            dataLayer.push({
              'userMessage': {
                'messageType': 'success',
                'messageName': 'Successfully re-sent Review Invitations on Collect Reviews View',
                'displayedMessage': 'Review invitations successfully sent'
              }
            })
          } else {
            flash(failMessage, 'is-danger')
            dataLayer.push({
              'userMessage': {
                'messageType': 'error',
                'messageName': 'Failed resending Review Invitations on Collect Reviews View due to status != queued',
                'displayedMessage': failMessage
              }
            })
          }
          this.bulkInvites.isSending = false
        })
          .catch(() => {
            flash(failMessage, 'is-danger')
            this.bulkInvites.isSending = false
            dataLayer.push({
              'userMessage': {
                'messageType': 'error',
                'messageName': 'Failed resending Review Invitations on Collect Reviews View due to server error',
                'displayedMessage': failMessage
              }
            })
          })
      }
    },
    sendBulkInvitesCnfm () {
      this.bulkInvitesModal.show = true
      this.bulkInvitesModal.isSingleSend = false
    },
    sendSingleInviteCnfm (email, token) {
      this.singleInvite = {email, token}
      this.bulkInvitesModal.show = true
      this.bulkInvitesModal.isSingleSend = true
    },
    canResend (item) {
      return item.converted === null && item.type !== 'GMB'
    },
    canAddToBulkResend (history) {
      if ('file_uploaded_emails' in history && history.file_uploaded_emails.length) {
        // Folder
        let itemsCount = 0
        _.forEach(history.file_uploaded_emails, item => {
          if (itemsCount) {
            return false
          }
          itemsCount += this.canResend(item) ? 1 : 0
        })
        return itemsCount
      } else {
        // History row
        return this.canResend(history)
      }
    },
    isCheckedForResend (history) {
      const isChecked = item => {
        return `id-${item.id}` in this.bulkInvites.data
      }

      if ('file_uploaded_emails' in history && history.file_uploaded_emails.length) {
        // Folder
        let itemsCount = 0
        let checkedItemsCount = 0
        history.file_uploaded_emails.forEach(item => {
          if (this.canResend(item)) {
            ++itemsCount
            checkedItemsCount += isChecked(item) ? 1 : 0
          }
        })
        return itemsCount === checkedItemsCount
      } else {
        // History row
        return isChecked(history)
      }
    },
    addToBulkResend (isChecked, history) {
      if (!isChecked) {
        const removeItem = item => {
          this.$delete(this.bulkInvites.data, `id-${item.id}`)
        }

        if ('file_uploaded_emails' in history && history.file_uploaded_emails.length) {
          // Folder
          history.file_uploaded_emails.forEach(item => {
            removeItem(item)
          })
        } else {
          // History row
          removeItem(history)
        }
      } else {
        const addItem = item => {
          this.$set(this.bulkInvites.data, `id-${item.id}`, item.conversion_token)
        }

        if ('file_uploaded_emails' in history && history.file_uploaded_emails.length) {
          // Folder
          history.file_uploaded_emails.forEach(item => {
            if (this.canResend(item)) {
              addItem(item)
            }
          })
        } else {
          // History row
          addItem(history)
        }
      }
    },
    resendInvites (email, token) {
      if (email.length > 0) {
        const postData = {
          email: email,
          token: token
        }
        const failMessage = 'An unexpected error occurred. Please try again later'
        axios.post(`/marketing/${this.businessSlug}/resend-business-review-invitations`, postData)
          .then(({data}) => {
            if (data.status === 'queued') {
              this.getReviewInvitationsHistory()
              flash(`Review invitations successfully sent`, 'is-success')
              dataLayer.push({
                'userMessage': {
                  'messageType': 'success',
                  'messageName': 'Successfully re-sent Review Invitations on Collect Reviews View',
                  'displayedMessage': 'Review invitations successfully sent'
                }
              })
            } else {
              flash(failMessage, 'is-danger')
              dataLayer.push({
                'userMessage': {
                  'messageType': 'error',
                  'messageName': 'Failed resending Review Invitations on Collect Reviews View due to status != queued',
                  'displayedMessage': failMessage
                }
              })
            }
          })
          .catch(() => {
            flash(failMessage, 'is-danger')
            dataLayer.push({
              'userMessage': {
                'messageType': 'error',
                'messageName': 'Failed resending Review Invitations on Collect Reviews View due to server error',
                'displayedMessage': failMessage
              }
            })
          })
      }
    },
    getOpens (history) {
      let opens = 0
      if (history.mandrill_data) {
        let mandrillData = JSON.parse(history.mandrill_data)
        opens = mandrillData.opens
      }
      return opens
    },
    getClicks (history) {
      let clicks = 0
      if (history.mandrill_data) {
        let mandrillData = JSON.parse(history.mandrill_data)
        clicks = mandrillData.clicks
      }
      return clicks
    },
    getChannel (history) {
      if (history.is_sms_conversion) {
        return 'SMS'
      } else if (history.type === 'GMB') {
        return 'Google'
      } else if (history.type === 'WHATSAPP') {
        return 'Whatsapp'
      } else {
        return 'Email'
      }
    },
    /**
     * Make request to api to get review invites history
     * @returns {number | null}
     * @param {number} page page number to paginate to
     */
    getReviewInvitationsHistory (page = 0) {
      if (!page) {
        page = this.page
      } else {
        this.page = page
      }
      this.fetching_data = true
      axios.get(this.url(page))
        .then((response) => {
          this.reviewInvitationHistory = response.data.data
          response.data.data = undefined
          this.dataSet = response.data
          this.is_loading = false
          this.fetching_data = false
          this.activeSubscription = response.data.activeSubscription
          this.allCount = response.data.resendAllCount
          this.reviewInvitationHistory = this.reviewInvitationHistory.map(v => ({...v, expanded: false}))
        })
        .catch(() => {
          flash('You are not authorized to view this resource.', 'is-danger')
          this.is_loading = false
          this.fetching_data = false
          dataLayer.push({
            'userMessage': {
              'messageType': 'error',
              'messageName': 'Failed to get Review Invitation History on Collect Reviews View due to authorization error',
              'displayedMessage': 'You are not authorized to view this resource.'
            }
          })
        })
    },
    /**
     * Compute URI to make call to api with.
     * @param {string} page starting page to request
     * @return {string}
     */
    url (page) {
      let query = location.search.match(/page=(\d+)/)
      if (!page) {
        page = query ? query[1] : 1
      }
      return `/marketing/${this.businessSlug}/get-review-invitation-history/?page=${page}&startDate=${this.historyFilters.dateFilter.startDate}&endDate=${this.historyFilters.dateFilter.endDate}`
    },
    /**
     * Handle the date change filter actions
     * @param {object} dateFilter Date filter
     * @return {void}
     */
    historyHandleDateChange (dateFilter) {
      Object.assign(this.historyFilters.dateFilter, dateFilter)
      if (dateFilter.label === 'all_time') {
        this.getBusinessInfo()
          .then((data) => {
            this.historyFilters.dateFilter.startDate = data.reviewInvite.firstInvite ? moment(data.reviewInvite.firstInvite.created_at).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
            this.historyFilters.dateFilter.endDate = moment().format('YYYY-MM-DD')
            this.fetchAnalyticsStats()
            this.getReviewInvitationsHistory(1)
          })
      } else {
        this.fetchAnalyticsStats()
        this.getReviewInvitationsHistory(1)
      }
    },
    /**
     * Expand related row
     * @param {number} key Key
     * @return {void}
     */
    expandRow (key) {
      this.reviewInvitationHistory[key].expanded = !this.reviewInvitationHistory[key].expanded
    },
    /**
     * Calculate rate with rounded digits
     * @param {number} value Value of stat
     * @param {number} total Total count of stat
     * @param {boolean} bounced Bounced
     * @return {number}
     */
    calculateRate (value, total, bounced = false) {
      if (bounced === false) {
        bounced = 0
      }
      let rate = (value * 100) / (total - bounced)
      return !isNaN(rate) ? rate.toFixed(2) : 0
    },
    /**
     * Fetching the review analytics stats
     * @return {void}
     */
    fetchAnalyticsStats () {
      this.fetchReviewInvitesAnalytics(this.payload)
    },
    /**
     * Get conversion stats for the listing
     * @param {object} obj obj
     * @param {string} key key
     * @return {string}
     */
    countConversionStats (obj, key) {
      let totalObj = {total: obj.length}
      totalObj[key] = 0
      obj.forEach((val) => {
        if (val.mandrill_data && key !== 'conversions') {
          let jsonData = JSON.parse(val.mandrill_data)
          if (jsonData[key] > 0) {
            ++totalObj[key]
          }
        }
        if (val.converted && key === 'conversions') {
          ++totalObj[key]
        }
      })
      return `${totalObj[key]}/${totalObj.total}`
    }
  },
  filters: {
    prettyDate (date) {
      return moment(date).format('DD MMM YYYY')
    },
    notificationDate (date) {
      return moment(date).format('DD-MM-YYYY')
    },
    /**
     * Format the integer by separator (comma (,)) after three digits (e.g 1,530)
     * @param {string} val val
     * @return {string}
     */
    formatDigit (val) {
      return val.toLocaleString()
    },
    /**
     * Format the long strings to 17 and 3 ellipses
     * @param {string} value Value of stat
     * @return {string|number}
     */
    formatString (value) {
      return value ? value.substring(0, 17) + (value.length > 17 ? '...' : '') : value
    }
  }
}
</script>

<style lang="scss" scoped>
.is-align-items-center {
  align-items: center;
}

.margin-0 {
  margin: 0;
}

.custom-dropdown {
  padding-top: 0;
  max-width: 275px;
  max-height: 37px;
}

> > > .button.button-dropdown img {
  height: 17px !important;
  padding: 0 !important;
}

.page-layout {
  margin-left: 0;
}

.page-layout .page-layout-head {
  color: #58595b;
  font-size: 12px;
}

.header-filters {
  justify-content: flex-end;
}

.export-button {
  width: 130px;
  height: 35px;
  color: #58595b;
  border: solid 1px #58595b;
  font-size: 11px;
  border-radius: 2px;
}

.invite-history {
  margin-top: 26px;
}

.table td, .table th {
  font-size: 12px !important;
  border-bottom: 1px solid rgba(219, 219, 219, 0.4) !important;
}

.table-rows {
  background-color: #fff !important;
}

.file-table-rows {
  background-color: #f7f7f7 !important;
}

.cb-head-col {
  padding-right: 0 !important;
  padding-left: 0 !important;
  width: 91px;
}

.cb-col {
  padding-left: 0 !important;
}

.mock-cb {
  width: 13px;
  display: inline-block;
}

.converted-section .fa-check {
  color: #17be86;
}

.hovernwe {
  position: relative;
}

.level > .level-item:not(:last-child) {
  margin-right: 1.5rem;
}

/*Stats card CSS Begins*/
.stats-box {
  border: 1px solid rgba(88, 89, 91, 0.32);
  padding: 4px 10px 2px 11px;
  font-size: 12px;
  margin-bottom: 24px;
}

.stats-box__col {
  border-right: 1px solid #e8e9ec;
  width: 25%;
  text-align: center;
}

.stats-box__col:last-child {
  border-right: none;
}

.stats-box__col-head {
  border-bottom: 1px solid #e8e9ec;
  padding-bottom: 8px;
  padding-top: 9px;
}

.stats-box__divider {
  color: rgba(88, 89, 91, 0.32);
  padding-left: 12px;
  padding-right: 10px;
}

.direction-column {
  /*Mobile view*/
  @media screen and (max-width: 767px) {
    overflow: scroll;
  }
}

/*Stats card CSS Ends */

@media screen and (min-width: 1024px) and (max-width: 1211px) {
  .stats-box__col-head.padding-bottom-9 {
    padding-bottom: 27px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/collect-reviews/ReviewInviteHistory.vue